import { SecurityController } from '@/plugins/securityController';

export class StorageWars {
    public name: string;
    public val: string;
    private store: number;

    constructor(opt: any) {
        if (opt.name) {
            this.name = opt.name;
        } else {
            this.name = '';
        }
        if (opt.val) {
            this.val = opt.val;
        } else {
            this.val = '';
        }
        if (this.localTest()) {
            this.store = 0;
        } else if (this.seshTest()) {
            this.store = 1;
        } else {
            this.store = -1;
        }
    }
    public set(): boolean {
        return this.setter();
    }
    public get(): string {
        return this.getter() || '';
    }
    public clear(): void {
        switch (this.store) {
            case 0:
                window.localStorage.clear();
            case 1:
                window.sessionStorage.clear();
        }
    }
    private localTest(): boolean {
        try {
            window.localStorage.setItem('test', 'test');
            window.localStorage.removeItem('test');
            return true;
        } catch (e) {
            return false;
        }
    }
    private seshTest(): boolean {
        try {
            window.sessionStorage.setItem('test', 'test');
            window.sessionStorage.removeItem('test');
            return true;
        } catch (e) {
            return false;
        }
    }
    private setter(): boolean {
        switch (this.store) {
            case 0:
                window.localStorage.setItem(this.name, this.val);
                return true;
            case 1:
                window.sessionStorage.setItem(this.name, this.val);
                return true;
            case -1:
                return false;
            default:
                return false;
        }
    }
    private getter(): string | null {
        switch (this.store) {
            case 0:
                this.val = window.localStorage.getItem(this.name) || '';
                return this.val;
            case 1:
                this.val = window.sessionStorage.getItem(this.name) || '';
                return this.val;
            case -1:
                return null;
            default:
                return null;
        }
    }
}

export const GetUserName = () => {
    return new SecurityController(null, null).getUser();
}
